module.exports = __webpack_public_path__ + "media/images/pc/top/icon-station-330fffae8b64b81df7ee5af50056becc.svg";